import { memo } from 'react';

// @ts-ignore untyped file
import ConnectedMessageEditor from '../../message-editor/containers/ConnectedMessageEditor';
// @ts-ignore untyped file
import ConnectedThreadHistory from '../../thread-history/containers/ConnectedThreadHistory';
// @ts-ignore untyped file
import ConnectedAlerts from '../containers/ConnectedAlerts';
// @ts-ignore untyped file
import ConnectedWidgetBranding from '../containers/ConnectedWidgetBranding';
import ErrorBoundary from '../../components/ErrorBoundary';
import AIPromptsContainerInsideChat from '../../ai-prompt-recommendations/components/AIPromptsContainerInsideChat';
import SpotlightAIDisclaimer from 'conversations-visitor-experience-components/visitor-widget/components/SpotlightAIDisclaimer';
import SpotlightClosedConversationBanner from 'conversations-visitor-experience-components/visitor-widget/components/SpotlightClosedConversationBanner';
import FadeSlideInTransition from '../../transition/FadeSlideInTransition';
import { useAppSelector } from '../../buildStore';
import { getUseSpotlightLauncher } from '../../widget-data/selectors/widgetDataSelectors';
import { getIsUngatedForAiSdr } from '../../widget-data/operators/getIsUngatedForAiSdr';
import ConsentPrompts from './ConsentPrompts';
import ThreadHistoryError from './ThreadHistoryError';
import useNewThreadPrompt from '../hooks/useNewThreadPrompt';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function UnifiedThreadView({
  isThreadStarted,
  isThreadTransferred,
  onSetMessageTextExternally,
  renderCookieConsentPrompt,
  shouldHideMessageEditor,
  shouldHideAlerts,
  disclaimerText,
  showingGdprProcess,
  showingHsBranding,
  toggleOnAndOffInputFocus
}) {
  const isSpotlight = useAppSelector(getUseSpotlightLauncher);
  const hasThreadHistoryMenu = !getIsUngatedForAiSdr();
  const isNewThreadPromptVisible = useNewThreadPrompt({
    isThreadStarted,
    isThreadTransferred,
    toggleOnAndOffInputFocus
  });
  const showAlerts = !isNewThreadPromptVisible && !shouldHideAlerts;
  const showMessageEditor = !isNewThreadPromptVisible && !shouldHideMessageEditor;
  const showClosedConversationBanner = isSpotlight && isNewThreadPromptVisible;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ErrorBoundary, {
      renderError: ThreadHistoryError,
      errorLoggingTitle: "ConnectedThreadHistory",
      children: /*#__PURE__*/_jsx(ConnectedThreadHistory, {
        shouldRenderNewThreadPrompt: isNewThreadPromptVisible,
        isChatTransferred: isThreadTransferred
      })
    }), /*#__PURE__*/_jsx(ConsentPrompts, {
      isSpotlight: isSpotlight,
      renderCookieConsentPrompt: renderCookieConsentPrompt,
      showingGdprProcess: showingGdprProcess
    }), !shouldHideMessageEditor && /*#__PURE__*/_jsx(AIPromptsContainerInsideChat, {}), showAlerts && /*#__PURE__*/_jsx(ConnectedAlerts, {}), showClosedConversationBanner && /*#__PURE__*/_jsx(SpotlightClosedConversationBanner, {
      hasThreadHistoryMenu: hasThreadHistoryMenu
    }), /*#__PURE__*/_jsx(FadeSlideInTransition, {
      in: isSpotlight && Boolean(disclaimerText),
      duration: 400,
      direction: "bottom",
      addEndListener: () => {},
      children: /*#__PURE__*/_jsx(SpotlightAIDisclaimer, {
        disclaimerText: disclaimerText
      })
    }), showMessageEditor && /*#__PURE__*/_jsx(ConnectedMessageEditor, {
      onSetMessageTextExternally: onSetMessageTextExternally
    }), showingHsBranding && /*#__PURE__*/_jsx(ConnectedWidgetBranding, {})]
  });
}
UnifiedThreadView.displayName = 'UnifiedThreadView';
export default /*#__PURE__*/memo(UnifiedThreadView);